module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "panelChart9"
    }
  }, [(_vm.showAddModal) ? _c('add-representatives', {
    attrs: {
      "closeAction": _vm.closeAddModal,
      "representatives": _vm.representatives,
      "accountId": _vm.accountId
    },
    on: {
      "representativeAdded": _vm.refreshRepresentatives
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel-title top-margin"
  }, [_vm._v("Authorized representatives")]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), (_vm.representatives.length === 0) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.representatives.length > 0) ? _c('div', {
    class: {
      'table-fixed-header--md cols-4': _vm.representatives.length > 6, 'table-responsive': true, 'bottom-margin': true
    }
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.representatives), function(representative, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-left"
    }, [_c('a', {
      staticClass: "account-representative",
      on: {
        "click": function($event) {
          _vm.goToUserView(representative.id, representative.userType, representative.firstName)
        }
      }
    }, [_vm._v(_vm._s(representative.fullName))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.getUserTypeLabel(representative.userType)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(_vm.canRepresentativeBePrimary(representative.userType)) ? _c('div', {
      class: {
        'radio-item': true, 'radio-item-unselected': !(representative.id === _vm.primaryInvestorId)
      },
      style: ({
        pointerEvents: _vm.isReadOnly ? 'none' : null,
        opacity: _vm.isReadOnly ? 0.5 : 1
      }),
      on: {
        "click": function($event) {
          _vm.attemptUpdatePrimaryInvestor(representative)
        }
      }
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "readonly": ""
      },
      domProps: {
        "value": true
      }
    }), _vm._v(" "), _c('label')]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(_vm.isDeleteEnabled) ? _c('button', {
      staticClass: "btn btn-trash",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.attemptRepresentativeDelete(representative)
        }
      }
    }, [_c('em', {
      staticClass: "fa fa-trash fa-2x delete-icon"
    })]) : _vm._e()])])
  }))])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-lg btn-add-representative",
    attrs: {
      "disabled": _vm.isReadOnly
    },
    on: {
      "click": _vm.openAddModal
    }
  }, [_vm._v("Add new representative")]), _vm._v(" "), (_vm.isIndividualAccount) ? _c('div', {
    staticClass: "panel-body account-notice"
  }, [_vm._m(2)]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "alert alert-info alert-dismissible",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n        No authorized representatives found.\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left"
  }, [_vm._v("Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("User type")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Primary user")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Action")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-info alert-dismissible mt-lg",
    attrs: {
      "role": "alert"
    }
  }, [_c('p', [_c('em', {
    staticClass: "icon-info pr-sm"
  }), _vm._v("The primary investor for an INDIVIDUAL account cannot be changed")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18cec56b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AccountRepresentatives.vue
// module id = 2109
// module chunks = 1